import { render, staticRenderFns } from "./ObservacionCasoSidebar.vue?vue&type=template&id=3399f055&scoped=true"
import script from "./ObservacionCasoSidebar.vue?vue&type=script&lang=js"
export * from "./ObservacionCasoSidebar.vue?vue&type=script&lang=js"
import style0 from "./ObservacionCasoSidebar.vue?vue&type=style&index=0&id=3399f055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3399f055",
  null
  
)

export default component.exports